import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
    // eslint-disable-next-line no-useless-concat
 apiKey: "AIza" + "SyCqWfexTKEh1wwEEJ-ChiauaTEnJJrgbK4",
  authDomain: "peekit-gg.firebaseapp.com",
  projectId: "peekit-gg",
  storageBucket: "peekit-gg.firebasestorage.app",
  messagingSenderId: "669652950687",
  appId: "1:669652950687:web:c9a4ef463dd718b1434caa"
};

// Odpalamy silnik Firebase
const app = initializeApp(firebaseConfig);

// Wyciągamy na zewnątrz Autoryzację (logowanie) i Bazę Danych (Firestore),
// żeby nasz App.js mógł z nich swobodnie korzystać!
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);